(function ($, njm) {
    'use strict';

    njm.views.featuredNewslist = Backbone.View.extend({

        events: {
        	"click button": "validate",
			"focus #news-release-search.validated": "validate",
			"focus #news-release-search.validated + button": "validate"
		},
		
		initialize: function() {
			var $this = this;
			
			this.form = this.$("form");
			
			this.formField = this.$("#news-release-search");
			
			this.regexPattern = this.formField.attr("data-val-regex");
		
			this.regexErrorText = this.formField.attr("data-val-regex-error");
			
			this.requiredErrorText = this.formField.attr("data-val-required");
			
			this.errorTooltip = this.$("#searchErrorMsg");
			
			$(document).on('click focusin', function(e) {	
				if ($(e.target).closest('.comp-featured-newslist .search').length === 0) {
					console.log('document click/focus');
					$this.hideError();
				}
			});
		},
		
		validate: function() {
			if (this.formField.val().trim() === '') {
				this.errorTooltip.text(this.requiredErrorText);
				this.form.addClass('haserror');
				this.formField.removeClass('validated');
				return false;
			} else {
				var val = this.formField.val(),
					regex = new RegExp(this.regexPattern),
					valid = regex.test(val);
				
				if (!valid) {
					this.errorTooltip.text(this.regexErrorText);
					this.form.addClass('haserror');
					this.formField.addClass('validated');
				}
				
				return valid;
			}
		},
		
		hideError: function(e) {
			this.form.removeClass('haserror');
		}
		
	});
})(jQuery, njm);